//shared containers
import { Footer } from '@/containers-m/Footer';
import { Navigation } from '/containers-m/';

//containers
import {
  Hero,
  WatchItRunYourFreight,
  HowItWorks,
  RunsOnYourStack,
  TheRestOfTheLineup,
  EndCTA,
} from '../containers';

//styles
import {
  PageWrapper,
  DocumentCollectionAndFilingGlobalStyle,
} from './DocumentCollectionAndFiling.styles';

const hero = {
  slug: 'document-collection-and-filing',
  title: 'Document Collection & Filing',
  description:
    'Every quote, tender, rate confirmation, BOL, POD and invoice — captured as it arrives, classified, and filed against the right shipment. Without anyone sorting an inbox.',
  metric: '70–90%',
  metricLabel: 'less document-handling time',
  // metricSource: 'MEASURED AT BUNZL',
};

const watchItRun = {
  title: 'Docs missing on delivered loads',
  stageHeadTitle: '3 delivered loads are missing signed BOLs and a rate con.',
  stageHeadMeta: 'Documents · #LS-48180',
  rows: [
    {
      time: '15:12:04',
      text: '3 delivered loads flagged — documents missing in your TMS.',
    },
    {
      time: '15:12:06',
      text: 'Emailed and called each carrier for the signed BOL and rate con.',
    },
    {
      time: '15:12:40',
      text: '2 back — read, validated against the shipment, filed.',
    },
    {
      time: '15:13:20',
      text: '1 carrier sent the wrong file — flagged and re-requested.',
    },
    {
      time: '15:14:02',
      text: 'All 3 filed to your TMS. Every doc matched to its load.',
    },
  ],
  summaryText:
    'A stack of delivered loads was missing paperwork. Loadsmart AI chased every carrier by email and phone, read and validated each document, caught a wrong file, and filed all three to your system of record — your team chased none of them.',
  agentBadge: 'Docs Agent',
  escalationTitle: 'It does not guess.',
  escalationText:
    'If a document is missing, unreadable, or ambiguous, the agent stops and hands it to a person with the context already attached. It will never invent a load number to close a gap.',
};

const howItWorks = {
  stepsTitleWhite: 'Captures every document, files it,',
  stepsTitleGradient: 'and tells you what’s still missing.',
  steps: [
    {
      title: 'Collects',
      description:
        'Picks up documents as they arrive — inbound email attachment or carrier portal upload — without anyone forwarding them anywhere.',
    },
    {
      title: 'Classifies',
      description:
        'Identifies each document by type: quote, tender, rate confirmation, bill of lading, proof of delivery, or invoice.',
    },
    {
      title: 'Matches and files',
      description:
        'Extracts the load number, carrier and dates, ties the document to the correct shipment record, and files it.',
    },
    {
      title: 'Flags the gap',
      description:
        'Surfaces what is still missing while there is still time to chase it.',
    },
  ],
  outcomes: [
    {
      title: 'Settlement closes faster',
      description:
        'PODs and invoices are matched the moment they arrive, so there is no gap between delivery and payment approval.',
    },
    {
      title: 'The audit trail stays clean',
      description:
        'Every document is tied to its shipment at arrival, so there’s nothing to reconstruct when a dispute comes up.',
    },
    {
      title: 'Hours come back',
      description:
        'Your team stops spending afternoons filing paperwork instead of moving freight.',
    },
  ],
};

const lineupCards = [
  {
    slug: 'tracking-and-status-updates',
    title: 'Tracking & Status Updates',
    description:
      'We get status from carriers so your team stops making check calls, and push clean updates to the people who need them.',
  },
  {
    slug: 'tender-failures',
    title: 'Tender Failures',
    description:
      'When a tender falls through, we re-tender down your routing guide and re-book, before the miss ever reaches your team.',
  },
  {
    slug: 'proactive-load-audits',
    title: 'Proactive Load Audits',
    description:
      'We check every load before pickup and flag at-risk transit early, so problems surface before they turn into penalties.',
  },
  {
    slug: 'claims-processing',
    title: 'Claims Processing',
    description:
      'We gather the documentation, validate the claim, and draft the response for your approval, so claims get filed and recovered.',
  },
  {
    slug: 'scheduling-and-re-scheduling',
    title: 'Scheduling & Re-Scheduling',
    description:
      'We book dock appointments against carrier and facility availability, and when a pickup slips, we re-schedule and notify everyone who needs to know.',
  },
];

function DocumentCollectionAndFiling() {
  return (
    <PageWrapper>
      <DocumentCollectionAndFilingGlobalStyle />
      <Navigation theme="dark" />
      <Hero {...hero} />
      <WatchItRunYourFreight {...watchItRun} />
      <HowItWorks {...howItWorks} />
      <RunsOnYourStack />
      <TheRestOfTheLineup cards={lineupCards} />
      <EndCTA agentName="Document Collection & Filing" />
      <Footer />
    </PageWrapper>
  );
}

export default DocumentCollectionAndFiling;
export { DocumentCollectionAndFiling };
